const TileSets = {
  membershipOverview: 'membershipOverview',
  documentsPageAds: 'documentsPageAds',
};

export default TileSets;
